import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { CultureService } from 'src/app/modules/core/services/culture.service';
import { DocumentReader } from 'src/app/modules/core/store/models';
import { StatusByChannelCellData } from './status-per-channel-model';
import { ChannelSelectionService } from 'src/app/modules/communications/services/channel-selection-service';

@Component({
    selector: 'app-status-per-channel-cell',
    templateUrl: './status-per-channel-cell.component.html',
    styleUrls: ['./status-per-channel-cell.component.scss'],
    standalone: false
})
export class StatusPerChannelCellComponent implements ICellRendererAngularComp {
  statuses: StatusByChannelCellData[];

  constructor(private translateService: TranslateService, private channelSelectionService: ChannelSelectionService) {}

  agInit(params: any): void {
    this.statuses = this.generateStatuses(this.getValueToDisplay(params));
  }

  refresh(params: ICellRendererParams): boolean {
    this.statuses = this.generateStatuses(this.getValueToDisplay(params));
    return true;
  }

  private generateStatuses(value: string): StatusByChannelCellData[] {
    let statuses: StatusByChannelCellData[] = [];
    if (!!value) {
      try {
        statuses = JSON.parse(value);
        return statuses;
      }
      catch(e) {
      }
    }
    return statuses;
  }

  getValueToDisplay(params: any) {
    return params.value;
  }
}
